import React from "react";
import { WhatsAppOutlined, ArrowUpOutlined } from "@ant-design/icons";

export default function HoveringButtons() {
    const handleScrollToTop = () => {
        const scrollDuration = 1000;
        const startPosition =
            document.documentElement.scrollTop;
        const startTime = performance.now();
        const easeInOutQuad = (t) =>
            t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        const scroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / scrollDuration, 1);
            const easedProgress = easeInOutQuad(progress);
            const position = startPosition * (1 - easedProgress);
            window.scrollTo(0, position);
            if (progress < 1) {
                requestAnimationFrame(scroll);
            }
        };
        requestAnimationFrame(scroll);
    };
    const handleWhatsAppClick = () => {
        const phoneNumber = "+923111266555";
        const whatsappUrl = `https://wa.me/${phoneNumber}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <div
            className="fixed bottom-5 right-5 gap-y-4 flex flex-col"
            style={{ zIndex: 9999 }}
        >
            <div
                style={{
                    background: "#FECC7B",
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100px",
                }}
                className="hover:cursor-pointer"
                onClick={handleScrollToTop}
            >
                <ArrowUpOutlined style={{ fontSize: "30px", color: "white" }} />
            </div>
            <div
                style={{
                    background: "#25D366",
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100px",
                }}
                className="hover:cursor-pointer"
                onClick={handleWhatsAppClick}
            >
                <WhatsAppOutlined
                    style={{ fontSize: "30px", color: "white" }}
                />
            </div>
        </div>
    );
}
